import styled from "styled-components";

export const CategorySelectMenu = styled.ul`
    margin: 0;
    padding: 0.25rem 0;

    list-style: none;
`;
